import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="accordion"
export default class extends Controller {
  static targets = ["header", "panel"];

  toggleAccordion() {
    const isCurrentlyActive = this.headerTarget.classList.contains("active");

    const headers = document.querySelectorAll(
      "[data-accordion-target='header']"
    );
    const panels = document.querySelectorAll("[data-accordion-target='panel']");

    headers.forEach((header) => {
      header.classList.remove("active");
    });

    panels.forEach((panel) => {
      panel.classList.add("hidden");
    });

    if (!isCurrentlyActive) {
      this.headerTarget.classList.add("active");
      this.panelTarget.classList.remove("hidden");
    }
  }
}
